import { propOr, includes, equals, always, cond, T } from 'ramda';
import { offerCodeEnum } from '@@views/_common/enums';

export const extraMailInfos = ({ getMiddleText, risque, nomClient, customerEmail, context, customerCivility, customerLastName,
  userFirstName,
  userLastName }) => {

  const getCivilityLabel = cond([
    [equals('MISTER'), always('Monsieur')],
    [equals('MISS'), always('Madame')],
    [T, always('')]
  ]);
  const offerCode = propOr('', 'offerCode', context);
  const activeUserRoles = propOr([], 'activeUserRoles', context);
  const isBroker = includes('BROKER', activeUserRoles);
  const civilityLabel = getCivilityLabel(customerCivility);
  const isSouscriptionRecap = equals(
    'SOUSCRIPTION_RECAP',
    propOr('', 'viewId', context)
  );

  const objectKey = isSouscriptionRecap
    ? 'EMAIL_RECAP_OBJECT_DEFAULT_VALUE'
    : 'EMAIL_OBJECT_DEFAULT_VALUE';

  const bodyKey = isSouscriptionRecap
    ? 'EMAIL_RECAP_BODY_DEFAULT_VALUE'
    : 'EMAIL_BODY_DEFAULT_VALUE';

  if (offerCode === offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION) {
    return {
      object: isBroker
        ? 'Votre projet d’assurance Celebea Prévoyance Pro'
        : 'Votre projet d’assurance Garance Prévoyance Pro',
      body: getMiddleText('EMAIL_BODY_DEFAULT_VALUE', {
        civiliteClient: civilityLabel,
        nomClient: customerLastName,
        nomAgent: userLastName,
        prenomAgent: userFirstName
      }),
      email: customerEmail
    };
  }

  return {
    object: getMiddleText(objectKey, { risque, nomClient }),
    body: getMiddleText(bodyKey, { risque, nomClient }),
    email: customerEmail
  };
};
